import { queryClient } from 'api/services/queryClient';
import { useServices } from 'containers/services';
import type { DeleteCreditInvoiceArg, DeleteCreditInvoiceResponse } from 'lib/services';
import { type UseMutationResult, useMutation } from 'react-query';
import { MUTATION_KEYS, QUERY_KEYS } from 'utils/queryKeys';
import { useAppNotifications } from 'hooks';
import { getErrorMessage } from 'utils/getErrorMessage';

export const useDeleteCreditInvoice = (): UseMutationResult<
  DeleteCreditInvoiceResponse,
  unknown,
  DeleteCreditInvoiceArg
> => {
  const notify = useAppNotifications();
  const { creditInvoicesApiClient } = useServices();

  return useMutation((arg: DeleteCreditInvoiceArg) => creditInvoicesApiClient.delete(arg), {
    mutationKey: MUTATION_KEYS.creditInvoices.deleteOne(),
    onError: error => {
      notify.error({
        message: 'There was an error while deleting credit invoice',
        description: getErrorMessage(error),
      });
    },
    onSuccess: () => {
      notify.success({
        message: `Credit invoice deleted`,
      });
      queryClient.invalidateQueries(QUERY_KEYS.creditInvoices.all());
    },
  });
};
